import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { commitChangeMonitoring } from '@api/manageNetworkElementConfigurations';

import { IWithUpdateId } from '@interfaces/networkElementConfigurations/dto/networkElementConfigurationsDTO';

import { EUserRoles } from '@enums/common';

import { NETWORK_ELEMENT_COMMIT_CHANGE_MONITORING } from '@constants/queryKeys';

interface IUseMutateChangeMonitoringCommitReturned {
	isLoadingCommitChangeMonitoring: boolean;
	commitChange: UseMutateFunction<any, any, IWithUpdateId, any>;
}

const useMutateChangeMonitoringCommit = (
	onSuccess?: () => void,
): IUseMutateChangeMonitoringCommitReturned => {
	const {
		isLoading,
		mutate,
	} = useMutation<IWithUpdateId>({
		mutationKey: [NETWORK_ELEMENT_COMMIT_CHANGE_MONITORING],
		mutationFn: commitChangeMonitoring,
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		onSuccess,
	});

	return {
		isLoadingCommitChangeMonitoring: isLoading,
		commitChange: mutate,
	};
};

export default useMutateChangeMonitoringCommit;
